export const envVars = {
  APP_NAME: 'discovery-mf-dashboard',
  PUBLIC_URL: process.env.PUBLIC_URL || '',
  APP_ENV: process.env.APP_ENV || '',
  LOGIN_URL: process.env.LOGIN_URL || '',
  LEAD_FORM_AUTO_DOMAIN_NAME: process.env.LEAD_FORM_AUTO_DOMAIN_NAME || '',
  LEAD_FORM_HOME_DOMAIN_NAME: process.env.LEAD_FORM_HOME_DOMAIN_NAME || '',
  URL_PAYROLL: process.env.URL_PAYROLL || '',
  URL_HOME_REFI_TIMELINE: process.env.URL_HOME_REFI_TIMELINE || '',
  URL_AUTO_EQUITY: process.env.URL_AUTO_EQUITY || '',
  URL_LEAD_REVIEW_AUTO: process.env.URL_LEAD_REVIEW_AUTO || '',
  URL_LEAD_REVIEW_HOME: process.env.URL_LEAD_REVIEW_HOME || '',
};
